import './styles.css';
import PageTitle from '../../../components/Accessibility/PageTitle';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import DefaultText from '../../../components/Accessibility/DefaultText';
import { sxCheckbox } from './sxProps';
import { Checkbox, FormControlLabel } from '@mui/material';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { aceiteNaoMostrarNovamente, getMostrarNovamenteInstrucoes } from '../../../services/SaudeBemEstar/SaudeEmocionalService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/pro-duotone-svg-icons';
import { RetornaAceiteTermoResponse } from '../../../interfaces/entities/RetornaAceiteTermoResponse';
import { sxCheckboxContrast } from '../../../assets/styles/CommonSxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { AutoAvaliacaoInfoPage } from './AutoAvaliacaoInfo';

const AutoAvaliacaoInstrucoes: React.FC<AutoAvaliacaoInfoPage> = ({ onBack, onNext }) => {
  const accessibility = useAccessibility()
  const [checked, setChecked] = useState<boolean>(false);
  const [acceptTerms, setAcceptTerms] = useState<RetornaAceiteTermoResponse | null>(null);

  useEffect(() => {
    getMostrarNovamenteInstrucoes().then((response) => setAcceptTerms(response))
  }, [])

  const handleNext = async () => {
    if (acceptTerms !== null && checked) {
      await aceiteNaoMostrarNovamente(acceptTerms.idTermoResponsabilidade, acceptTerms.idOperador)
    }
    onNext()
  }

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const instrucoesText = [
    "Leia atentamente cada uma das afirmações do teste;",
    "Escolha a opção que melhor indica o quanto a afirmação abaixo aplica-se a você na última semana;",
    "Não há resposta certa ou errada;",
    "Não leve muito tempo para indicar sua resposta em cada afirmação."
  ];

  return (
    <div className='page-container'>
      <PageTitle text="Instruções" />

      <DefaultText text="Antes de iniciar a avaliação, veja as instruções a seguir:" />

      <div className="instrucoes-container">
        {
          instrucoesText.map(text => (
            <div key={text} className="flex-row align-start instruction">
              <div className="instruction-icon-holder">
                <FontAwesomeIcon style={{ marginRight: '8px' }} icon={faSquareCheck} className='check-icon' color="#00995D" />
              </div>
              <DefaultText text={text} />
            </div>
          ))
        }
      </div>

      <div className="instrucoes-container">
        <DefaultText text="<b>Importante:</b> Esse teste não é um instrumento de avaliação psicológica regulamentada pelo CFP -Conselho Federal de Psicologia. O teste deve ser utilizado apenas para fins de direcionamento e cuidados adequados." />
      </div>

      <DefaultButton onClick={handleNext} text="Ir para questões" />

      <div className='flex-row'>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleCheck}
              style={accessibility.contrastColorAccessibility} />
          }
          label="Não exibir mais esta tela"
          sx={accessibility.contrastMode ? sxCheckboxContrast : sxCheckbox} />
      </div>

      <VoltarButton onClick={onBack} />

    </div>
  )
}

export default AutoAvaliacaoInstrucoes;